import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { t } from 'i18next'
import { useRecoilValue } from 'recoil'
import { Button, Card, CardBody } from 'reactstrap'

import env from '../../env/src_config'
import { headersState, tokenState } from '../../recoil/recoil'
import { axiosError } from '../../helpers/response'
import { isNull } from '../../izUtils'
import { transformer, linker } from '../../helpers/fields'
import Spinner from '../../components/spinner/Spinner'
import DisplayFields from '../../helpers/displayFields'
import TimelineMapTracker from '../../components/maps/TimelineMapTracker'

const UsersLocation = () => {
    const Navigate = useNavigate();
    const { userId } = useParams()

    const headers = useRecoilValue(headersState);
    const tokenData = useRecoilValue(tokenState);
    const [inputs, setInputs] = useState(null)
    const [showErrors, setShowErrors] = useState(false)
    const [locations, setLocations] = useState([])

    useEffect(() => {
        if (!isNull(inputs)) setInputs(null)
        setShowErrors(false);
        updateData(false, null);

    }, [userId]) // eslint-disable-line react-hooks/exhaustive-deps

    const updateData = (save, passedInputs) => {
        let payload = { save };
        if (!isNull(passedInputs)) {
            // Get data from inputs
            const keys = Object.keys(passedInputs);
            payload.data = {};
            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedInputs[keys[i]].value) && passedInputs[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedInputs[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        axios.post(env.api + '/api/user/locations/' + userId, payload, {headers}).then(response => {
            if (!isNull(response.data.data)) setInputs(transformer(response.data.data));
            if (!isNull(response.data.locations)) setLocations(response.data.locations);
        }).catch(error => {
            axiosError(error, Navigate);
        });
    }

    const textChange = (value, name) => {
        let clonedInputs = {...inputs}
        clonedInputs[name].value = value;
        updateData(false, clonedInputs);
    }

    // Create fields
    const mapLinker = (field) => {
        const inputlinkerFields = {
            field,
            inputs,
            showErrors,
            component: {id: 'UsersLocation'},
            textHandler: (value, id) => textChange(value, id),
            selectHandler: (value, id) => textChange(value, id),
            dateHandler: (value, id) => textChange(value, id),
            booleanHandler: (value, id) => textChange(value, id),
        }

        if (tokenData.parsedToken.type === 'admin') {
            return linker(inputlinkerFields);
        } else {
            if (!isNull(inputs[field])) return <DisplayFields key={'display-'+inputs[field].name} data={inputs[field]} />
        }
    }

    return (
        <>
            <Card className="ribbon-wrapper">
                <CardBody>
                    <div className="ribbon ribbon-clip ribbon-primary">
                        <div className="d-flex align-items-center">{t('users.location.title')}</div>
                    </div>
                    {isNull(inputs) ?
                        <Spinner />
                        :
                        <>
                            <div className="theme-form">
                                { ['from', 'to', 'show_movement_points', 'distance'].map(field => mapLinker(field)) }
                            </div>
                            <div className='text-start mb-5'>
                                <Button color="primary" className="me-2" onClick={() => updateData(true, inputs)}>{t('save')}</Button>
                            </div>
                            {!isNull(locations) && locations.length > 0
                                ? <TimelineMapTracker locations={locations} />
                                : <div>{t('users.location.noData')}</div>
                            }
                        </>
                    }
                </CardBody>
            </Card>
            <hr/>
            <div className='d-flex flex-wrap justify-content-between mb-4'>
                <Button color="danger" className="mt-2 me-2" onClick={() => Navigate(-1)}>{t('back')}</Button>
            </div>
        </>
    )
}

export default UsersLocation